import React from "react";
import { useTable } from "react-table";
import { modifyCell, modifyCellHeader } from "./cell_formatter";
import Images from "../../utils/styles/images";

function Table({
  columns,
  data,
  handleActionHeaderClick,
  handleSortHeader,
  pageIndex,
  pageSize
}) {
  const { getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    data: data,
    columns: columns
  });

  return (
    <table className="transactions-table">
      <thead className="transactions-head-container">
        {headerGroups.map(headerGroup => (
          <tr
            {...headerGroup.getHeaderGroupProps()}
            className="transactions-head-row"
          >
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()} className="transactions-header">
                {modifyCellHeader(
                  column.render("Header"),
                  handleActionHeaderClick,
                  handleSortHeader
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps} className="transactions-table-body">
        {rows.length <= 0 ? (
          <tr className="transactions-table-empty-row">
            <td colSpan={14}>
              <div className="transactions-table-no-data">
                <img src={Images.noData.board} alt="no-data-found-board" />
                <p className="transactions-table-no-data-header">No result found</p>
                <p className="transactions-table-no-data-body">
                  We couldn’t find what you are looking for.<br /> Please try again.
                </p>
              </div>
            </td>
          </tr>
        ) : (
          rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="transactions-table-row">
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()} className="transactions-cell">
                      {modifyCell(
                        cell.render("Cell"),
                        pageIndex,
                        pageSize
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
}

export default Table;
